import v1serviceUrl from "./v1/serviceUrl";
import v2serviceUrl from "./v2/serviceUrl";
import { makeRequest, makeRequestWihActualStatus } from "./v1/request";
import Config from "../config";

export const getHomeMarkets = async (data) => {
  const requestData = { method: "post", url: v1serviceUrl.getHomeMarkets, data: data.payload };
  const resp = await makeRequest(requestData);
  return resp;
};
export const getHomeMarketsTwoCurrency = async (data) => {
  const requestData = { method: "post", url: v1serviceUrl.getHomeMarketsINRUSDT, data: data.payload };
  const resp = await makeRequest(requestData);
  return resp;
};

export const getHomeCMS = async (data) => {
  const requestData = { method: "post", url: v1serviceUrl.getHomeCMS, data: data.payload };
  const resp = await makeRequest(requestData);
  return resp;
};

export const tradeFanTknFeesAuth_API = async (data) => {
  const requestData = { method: "get", url: v2serviceUrl.tradeFanTknFeesAuth, options: { toastShow: true } };
  const resp = await makeRequest(requestData);
  return resp;
};

export const getVoucher_API = async (data) => {
  const requestData = { method: "get", url: v2serviceUrl.getVoucher };
  const resp = await makeRequest(requestData);
  return resp;
};

export const claimVoucher_API = async (data) => {
  const requestData = { method: "post", url: v2serviceUrl.claimVoucher, data: data.payload, options: { toastShow: true } };
  const resp = await makeRequest(requestData);
  return resp;
};

export const getProfitList_API = async (data) => {
  const requestData = { method: "post", url: v2serviceUrl.getProfitList, options: { toastShow: true } };
  const resp = await makeRequest(requestData);
  return resp;
};

export const getOrderDetail_API = async (data) => {
  const requestData = { method: "post", url: v2serviceUrl.getOrderDetail, data: data.payload };
  const resp = await makeRequest(requestData);
  return resp;
};
export const getUserReferralData = async (userId) => {
  const requestData = { method: "GET", url: Config.V1_API_URL + 'user/get-referral/' + userId };
  const resp = await makeRequestWihActualStatus(requestData);
  return resp;
};
export const getUserStakePayoutData = async () => {
  const requestData = { method: "GET", url: Config.V1_API_URL + 'user/get-commission' };
  const resp = await makeRequestWihActualStatus(requestData);
  return resp;
};
export const getUserClaimData = async () => {
  const requestData = { method: "GET", url: Config.V1_API_URL + 'stake-trade/get-claim-history' };
  const resp = await makeRequestWihActualStatus(requestData);
  return resp;
};